const general = {
    en: {
        chooseGameAvatar: "CHANGE AVATAR",
        round: "Round",
        win: "Win",
        cashedOut: "Cashed out",
        bet: "Bet",
        Multiplier: "Multiplier",
        Day: "Day",
        Month: "Month",
        Year: "Year",
        HugeWins: "HUGE WINS",
        BiggestWins: "BIGGEST WINS",
        Multipliers: "MULTIPLIERS",
        AllBets: "All Bets",
        MyBets: "My Bets",
        Top: "Top",
        PreviousRound: "Previous Round",
        User: "User",
        Cashout: "Cash out",
        Date: "Date",
        Fairness: "Fairness",
        ThisGame: "This game is",
        ProvablyFair: "Provably Fair",
        flewAway: "FLEW AWAY!",
        betControlBet: "Bet",
        betControlAuto: "Auto",
        previous: "Previous",
        rounds: "Rounds",
        betsBet: "Bets",
        totalWin: "Total win",
        reply: "Reply",
        roundResult: "Round Result",
        infoboard_bet: "Bets",
        round_history: "Round History",
        cash_out: "Cash Out",
        bet_control_cancel: "Cancel",
        bet_control_waiting_for_next_round: "Waiting for next round",
        all_bets_player: "Игрок",
        auto_bet: "Auto bet",
        auto_cash_out: "Auto Cash Out",
        disconnect_text: "You have been disconnected. Check connection and refresh your browser, or go back to landing page",
        connection_text: "Connection...",

        main_page_balance_amount: "Balance amount",
        mp_profile: "Profile",
        mp_deposit: "Deposit",
        mp_withdraw: "Withdraw",
        mp_detail: "Detail",
        mp_notifications: "Notifications",
        mp_support: "Support",
        mp_logout: "Logout",
        mp_my_wallets: "My Wallets",
        mp_personal_data: "Personal Data",
        mp_birthday: "Birthday",
        mp_name: "Name",
        mp_verification_status: "Verification status",
        mp_verify: "Verify",
        mp_pass_verification: "Pass verification",
        mp_select_wallet_to_top_up: "Wallet for replenishment",
        mp_all_methods: "All methods",
        mp_available_methods: "Available methods for your region",
        mp_select_wallet_to_withdrawal: "Selected wallet",
        mp_all: "All",
        mp_awaiting: "Awaiting",
        mp_canceled: "Canceled",
        mp_completed: "Completed",
        mp_withdrawal_to: "Withdrawal to",
        mp_limit_of_one_withdrawal: "Limit of one withdrawal",
        mp_withdraw_funds: "Withdraw funds",
        mp_change: "Change",
        mp_minimum_amount_replenishment: "Minimum amount for replenishment",
        mp_continue: "Continue",
        mp_the_request_was_successfully: "The request was successfully accepted. Make a transfer of the specified amount to the specified card",
        mp_this_transfer_guarantees: "This transfer guarantees",
        mp_this_transfer_guarantees2: "that the funds will be credited to the AviatorWinn gambling account",
        mp_copy_the_exact: "Copy the exact amount shown in the field below. Based on this amount, we will determine that this is your payment and credit it automatically.",
        mp_amount_to_transfer: "Amount to transfer",
        mp_card_number_to_transfer: "Card number to transfer",
        mp_upload_payment_receipt: "Upload your payment receipt",
        mp_waiting_transfer: "We're waiting for your transfer",
        mp_paid: "PAID",
        mp_deposit_bid_text: "Your request for replenishment has been accepted and is awaiting receipt of funds within 12 hours.",
        mp_success: "Success",
        mp_error: "Error",
        mp_your_withdrawal_request: "Your withdrawal request has been accepted, please expect your funds to arrive within 24 hours",
        mp_an_error_occurred: "An error occurred, please try later",
        mp_incorrect_card_number: "Incorrect card number",
        mp_incorrect_wallet: "Incorrect wallet address",
        mp_not_enough: "Not enough funds",
        mp_minimum_withdrawal_amount: "Minimum withdrawal amount",
        mp_empty_detail: "You don't have a transaction yet.",
        mp_close: "Close",

        mp_notification_welcome: "Welcome to AviatorWinn. Thank you for choosing us. As a thank you, we will give you a 200% bonus on your first deposit for a replenishment of $ 50. We wish you success and big wins",

    },
    ru: {
        chooseGameAvatar: "СМЕНИТЬ АВАТАР",
        round: "Раунд",
        win: "Выигрыш",
        cashedOut: "Выведено средств",
        bet: "Ставка",
        Multiplier: "Множитель",
        Day: "День",
        Month: "Месяц",
        Year: "Год",
        HugeWins: "КУШИ",
        BiggestWins: "НАИБОЛ. ВЫИГР.",
        Multipliers: "КОЭФФ.",
        AllBets: "Все ставки",
        MyBets: "Мои ставки",
        Top: "Топ",
        PreviousRound: "Предыдущий раунд",
        User: "Игрок",
        Cashout: "Вывести",
        Date: "Время",
        Fairness: "Честность",
        ThisGame: "В игре использ.",
        ProvablyFair: "Provably Fair",
        flewAway: "УЛЕТЕЛ!",
        betControlBet: "Cтавка",
        betControlAuto: "Авто",
        previous: "Предыдущее",
        rounds: "Раунды",
        betsBet: "Ставки",
        totalWin: "Общий выигрыш",
        reply: "Ответить",
        roundResult: "Результат раунда",
        infoboard_bet: "Ставки",
        round_history: "История раундов",
        cash_out: "Вывод",
        bet_control_cancel: "Отмена",
        bet_control_waiting_for_next_round: "Ожидаем новый раунд",
        all_bets_player: "Player",
        auto_bet: "Автоставка",
        auto_cash_out: "Авто кешаут",
        disconnect_text: "Вы были отключены. Проверьте соединение и обновите браузер или вернитесь на главную страницу",
        connection_text: "Подключение...",

        main_page_balance_amount: "Баланс счета",
        mp_profile: "Профиль",
        mp_deposit: "Пополнение",
        mp_withdraw: "Вывод",
        mp_detail: "История транзакций",
        mp_notifications: "Уведомлении",
        mp_support: "Служба поддержки",
        mp_logout: "Выйти",
        mp_my_wallets: "Мои кошельки",
        mp_personal_data: "Персональные данные",
        mp_birthday: "Дата рождение",
        mp_name: "Имя",
        mp_verification_status: "Статус верификации",
        mp_verify: "Верифицирован",
        mp_pass_verification: "Пройти верификацию",
        mp_select_wallet_to_top_up: "Пополняемый кошелек",
        mp_all_methods: "Способы пополнение",
        mp_available_methods: "Доступные методы пополнение для вашего региона",
        mp_select_wallet_to_withdrawal: "Выбранный кошелек",
        mp_all: "Все",
        mp_awaiting: "В обработке",
        mp_canceled: "Отмененный",
        mp_completed: "Выполнен",
        mp_withdrawal_to: "Вывести на",
        mp_limit_of_one_withdrawal: "Лимит одного вывода",
        mp_withdraw_funds: "Вывести средства",
        mp_change: "Изменить",
        mp_minimum_amount_replenishment: "Минимальная сумма для пополнения",
        mp_continue: "Далее",
        mp_the_request_was_successfully: "Запрос успешно принят. Сделайте перевод указанной суммы на указанную карту",
        mp_this_transfer_guarantees: "Этот перевод гарантирует",
        mp_this_transfer_guarantees2: "что средства будут зачислены на игровой счет AviatorWinn.",
        mp_copy_the_exact: "Скопируйте точную сумму, указанную в поле ниже. На основании этой суммы мы определим, что это ваш платеж, и зачислим его автоматически.",
        mp_amount_to_transfer: "Сумма для перевода",
        mp_card_number_to_transfer: "Номер карты для перевода",
        mp_upload_payment_receipt: "Загрузите чек ​​об оплате",
        mp_waiting_transfer: "Мы ждем вашего перевода",
        mp_paid: "ОПЛАТИЛ",
        mp_deposit_bid_text: "Ваша заявка на пополнение принята ожидайте поступление средств в течении 12 часов",
        mp_success: "Успех",
        mp_error: "Ошибка",
        mp_your_withdrawal_request: "Ваш запрос на вывод средств принят, ожидайте поступления средств в течение 24 часов.",
        mp_an_error_occurred: "Произошла ошибка, попробуйте позже",
        mp_incorrect_card_number: "Неправильный номер карты",
        mp_incorrect_wallet: "Неправильный адрес кошелька",
        mp_not_enough: "Недостаточно средств для вывода",
        mp_minimum_withdrawal_amount: "Минимальная сумма вывода",
        mp_empty_detail: "У вас еще нет транзакции",
        mp_close: "Закрыть",

        mp_notification_welcome: "Добро пожаловать в AviatorWinn. Спасибо, что выбрали нас. В качестве благодарности мы дадим вам бонус 200% на первый депозит за пополнение от $50 или эквивалентную сумму в другой валюте. Желаем вам успехов и больших выигрышей",

    },
    uz: {
        chooseGameAvatar: "Avatarni O'zgartirish",
        round: "Bo'lim",
        win: "Yutish",
        cashedOut: "Olingan pul",
        bet: "Pul tikish",
        Multiplier: "Ko'paytuvchi",
        Day: "Kun",
        Month: "Oy",
        Year: "Yil",
        HugeWins: "ULKAN YUTUQLAR",
        BiggestWins: "KATTA YUTUQLAR",
        Multipliers: "KO'PAYTUVCHI",
        AllBets: "Pul tikishlar",
        MyBets: "Men tikkanlar",
        Top: "Eng yuqori",
        PreviousRound: "Oldingi raund",
        User: "Foydalanuvchi",
        Cashout: "Pulni olish",
        Date: "Sana",
        Fairness: "Adolat",
        ThisGame: "Bu o'yin",
        ProvablyFair: "Provably Fair",
        flewAway: "UCHIB KETDI!",
        betControlBet: "Pul tikish",
        betControlAuto: "Avto",
        previous: "Oldingi",
        rounds: "Aylanalar",
        betsBet: "Tikishlar",
        totalWin: "Jami yutuq",
        reply: "Qayta javob berish",
        roundResult: "Aylana Natijasi",
        infoboard_bet: "Pul tikishlar",
        round_history: "Aylana tarixi",
        cash_out: "Pulni olish",
        bet_control_cancel: "Bekor qilish",
        bet_control_waiting_for_next_round: "Keyingi bo'limni kutish",
        all_bets_player: "O'yinchi",
        auto_bet: "Avtomatik pul tikish",
        auto_cash_out: "Avto pul olish",
        disconnect_text: "Server bilan aloqa uzilib qoldi. Intenetga ulanishni tekshiring va brauzeringizni yangilang yoki asosiy sahifaga qayting",
        connection_text: "Ulanish...",

        main_page_balance_amount: "Balans hisobi",
        mp_profile: "Profil",
        mp_deposit: "Pul kirgizish",
        mp_withdraw: "Pul chiqarish",
        mp_detail: "Tafsilot",
        mp_notifications: "Bildirishnomalar",
        mp_support: "Texnik yordam",
        mp_logout: "Chiqish",
        mp_my_wallets: "Mening hamyonlarim",
        mp_personal_data: "Shaxsiy ma'lumotlar",
        mp_birthday: "Tug'ilgan kun",
        mp_name: "Ismingiz",
        mp_verification_status: "Shaxs tasdiqlash xolati",
        mp_verify: "Tasdiqlangan",
        mp_pass_verification: "Shaxsni tasdiqlash",
        mp_select_wallet_to_top_up: "Pul tushiriladigan hamyon",
        mp_all_methods: "Hisob to'ldirish usullari",
        mp_available_methods: "Regioningizda mavjud bo'lgan hisob to'ldirish usullari",
        mp_select_wallet_to_withdrawal: "Tanlangan hamyon",
        mp_all: "Hammasi",
        mp_awaiting: "Kutilmoqda",
        mp_canceled: "Bekor qilingan",
        mp_completed: "Tasdiqlangan",
        mp_withdrawal_to: "Pul chiqarish",
        mp_limit_of_one_withdrawal: "Bir martalik pul chiqarish limitlari",
        mp_withdraw_funds: "Pul chiqarish",
        mp_change: "O'zgartirish",
        mp_minimum_amount_replenishment: "To'ldirish uchun minimal miqdor",
        mp_continue: "Keyingi",
        mp_the_request_was_successfully: "So'rov muvaffaqiyatli qabul qilind. Belgilangan miqdorni ko'rsatilgan kartaga o'tkazing",
        mp_this_transfer_guarantees: "O'tkazma kafolatlangan",
        mp_this_transfer_guarantees2: "ushbu o'tkazma mablag'larning AviatorWinn sizning hisobingizga o'tkazilishini kafolatlaydi",
        mp_copy_the_exact: "Quyidagi maydonda ko'rsatilgan aniq miqdorni nusxalang. Ushbu miqdorga asoslanib, biz sizning to'lovingizni aniqlaymiz va uni avtomatik ravishda hisobingizga tushiramiz.",
        mp_amount_to_transfer: "O'tkazish summa miqdori",
        mp_card_number_to_transfer: "O'tkazma uchun karta raqami",
        mp_upload_payment_receipt: "To'lov chekini yuklang",
        mp_waiting_transfer: "Sizning transferingizni kutamiz",
        mp_paid: "TO'LANDI",
        mp_deposit_bid_text: "Hisob to'ldirish so'rovnomangiz qabul qilingi va 12 soat ichida mablag' hisobingizga tushiriladi",
        mp_success: "Muvaffaqiyatli",
        mp_error: "Xatolik",
        mp_your_withdrawal_request: "Pul yechib olish bo'yicha so'rovingiz qabul qilindi, iltimos, mablag'ingiz 24 soat ichida kartangizga tushishini kuting",
        mp_an_error_occurred: "Xatolik yuz berdi, keyinroq urinib ko'ring",
        mp_incorrect_card_number: "Karta raqami noto'g'ri terilgan",
        mp_incorrect_wallet: "Hamyon raqami noto'g'ri",
        mp_not_enough: "Hisobingizda yetarli mablag' mavjud emas",
        mp_minimum_withdrawal_amount: "Minimal yechib olish miqdori",
        mp_empty_detail: "Sizning tranzaksiyalaringiz topilmadi",
        mp_close: "Yopish",

        mp_notification_welcome: "Добро пожаловать в AviatorWinn. Спасибо, что выбрали нас. В качестве благодарности мы дадим вам бонус 200% на первый депозит за пополнение от $50. Желаем вам успехов и больших выигрышей",
        
    }
}

export default general